import { setWorkerUrl } from 'maplibre-gl';
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

// MapLibre GL v6 resolves its worker via a dynamic `new URL(..., import.meta.url)`
// that bundlers can't statically discover, so every bundler consumer must call
// setWorkerUrl() with a bundler-resolved URL (MapLibre's v5-to-v6 migration guide).
setWorkerUrl(maplibreWorkerUrl);
